import { useAdminVerComo } from "@/contexts/AdminVerComoContext";
import { useAuth } from "@/contexts/AuthContext";
import { VerComoPersonasSelector } from "@/components/admin/VerComoPersonasSelector";

/**
 * "Ver como" del shell del admin: por persona. Se ve solo si el usuario puede impersonar; la lista
 * son las personas con acceso a vistas del admin y, al elegir a alguien, el menu lateral muestra
 * solo lo que su rol ve (solo presentacion, en solo lectura).
 */
export function AdminVerComoSelector({
  className,
  compact = false,
}: {
  className?: string;
  /** Variante para el header movil: boton mas angosto. */
  compact?: boolean;
}) {
  const { profile } = useAuth();
  const { persona, setPersona } = useAdminVerComo();
  if (profile?.puede_impersonar !== true) return null;
  return (
    <VerComoPersonasSelector
      rutas={["/admin/%"]}
      seleccionadoEmail={persona?.email ?? null}
      seleccionadoNombre={persona?.nombre}
      onElegir={setPersona}
      onLimpiar={() => setPersona(null)}
      compacto={compact}
      className={className}
    />
  );
}
